export interface RecoveryLink {
  token: string;
  purpose: 'reset' | 'invitation';
}
let captured: RecoveryLink | undefined;

// Imported before Sentry initialization so the fragment never becomes a page-view URL.
export function captureRecovery(): RecoveryLink | undefined {
  if (typeof window === 'undefined' || window.location.pathname !== '/auth/reset-password')
    return undefined;
  if (window.location.hash) {
    const params = new URLSearchParams(window.location.hash.slice(1));
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search
    );
    const token = params.get('token');
    const purpose = params.get('purpose');
    captured =
      token &&
      /^[A-Za-z0-9_-]{43}$/.test(token) &&
      params.get('application') === 'pbb' &&
      (purpose === 'reset' || purpose === 'invitation')
        ? { token, purpose }
        : undefined;
  }
  return captured;
}
export function releaseRecovery() {
  captured = undefined;
}
captureRecovery();
